var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 150,
    r: 136,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0C156.698 0 76 80.7 76 180C76 213.6 85.302 246.301 103.001 274.501L243.798 504.915C246.2 508.815 249.8 511.216 254.001 511.816C259.699 512.715 266.002 510.316 269.301 504.616L410.501 272.1C427.299 244.501 436 212.401 436 180C436 80.7 355.302 0 256 0ZM256 270C205.602 270 166 229.2 166 180C166 130.499 206.499 90 256 90C305.501 90 346 130.499 346 180C346 228.9 306.999 270 256 270Z",
    fill: "#FD003A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 0V90C305.501 90 346 130.499 346 180C346 228.9 306.999 270 256 270V511.991C261.119 512.11 266.383 509.656 269.3 504.616L410.5 272.1C427.299 244.501 436 212.401 436 180C436 80.7 355.302 0 256 0Z",
    fill: "#E50027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/mappin.04141f8d83d5d64d9f611df83c1c68aa.svg";
export { ForwardRef as ReactComponent };